import axios from '@/utils/request'

/**
 * 会议室列表
 */
const getMeetingList = (data) => axios({
  url: `meeting?pageSize=${data.pageSize}&pageIndex=${data.pageIndex}`
})

/**
 * 修改会议室标题
 */
const updateMeetingTitle = (data) => axios({
  url: 'meeting/order/meetingTitle',
  method: 'put',
  data
})

/**
 * 新增会议室
 */
const addMeeting = (data) => axios({
  url: 'meeting',
  method: 'post',
  data
})

/**
 * 会议室详情
 */
const getMeetingDetails = (uuid) => axios({
  url: `meeting/${uuid}`
})

/**
 * 编辑会议室
 */
const putMeeting = (data) => axios({
  url: 'meeting',
  method: 'put',
  data
})

/**
 * 删除会议室
 */
const deleteMeeting = (uuid) => axios({
  url: `meeting/${uuid}`,
  method: 'delete'
})

/**
 * 会议室预约列表
 */
const getAppointmentList = (params, options) => axios({
  url: 'meeting/order',
  params,
  options
})

/**
 * 导出会议室预约
 */
const appointmentExcel = params => axios({
  url: 'meeting/order/excel',
  responseType: 'arraybuffer',
  params
})

/**
 * 会议室预约详情
 */
const appointmentDetails = (uuid) => axios({
  url: `meeting/order/${uuid}`
})

/**
 * 增值服务列表
 */
const getAddServerList = (params, options) => axios({
  url: 'meeting/service',
  params,
  options
})

/**
 * 编辑增值服务
 */
const setAddServer = (data) => axios({
  url: 'meeting/service',
  method: 'put',
  data
})

/**
 * 新增增值服务
 */
const addMeetingServer = (data) => axios({
  url: 'meeting/service',
  method: 'post',
  data
})

/**
 * 删除增值服务
 */
const deleteServer = (data) => axios({
  url: `meeting/service/${data}`,
  method: 'delete'
})

/**
 * 编辑基础服务
 */
const setBasicServer = (data) => axios({
  url: 'meeting/baseService',
  method: 'put',
  data
})

/**
 * 基础服务
 */
const getBasicServer = () => axios({
  url: 'meeting/baseService'
})

/**
 * 会议功能列表
 */
const getMeetingFunList = (params, options) => axios({
  url: 'meeting/function',
  params,
  options
})

/**
 * 编辑会议功能
 */
const putMeetingFun = (data) => axios({
  url: 'meeting/function',
  method: 'put',
  data
})

/**
 * 删除会议功能
 */
const deleteMeetingFun = (uuid) => axios({
  url: `meeting/function/${uuid}`,
  method: 'delete'
})

/**
 * 新增会议功能
 */
const addMeetingFun = (data) => axios({
  url: 'meeting/function',
  method: 'post',
  data
})

/**
 * 编辑会议功能说明
 */
const setMeetingFun = (data) => axios({
  url: 'meeting/function/explain',
  method: 'put',
  data
})

/**
 * 会议功能说明
 */
const getMeetingFun = () => axios({
  url: 'meeting/function/explain'
})

/**
 * 场地布局
 */
const getPlaceList = () => axios({
  url: 'meeting/layout'
})

/**
 * 编辑场地布局
 */
const setPlaceLayout = (data) => axios({
  url: 'meeting/layout',
  method: 'put',
  data
})

/**
 * 新增场地布局
 */
const addPlaceLayout = (data) => axios({
  url: 'meeting/layout',
  method: 'post',
  data
})

/**
 * 删除场地布局
 */
const deletePlaceLayout = (uuid) => axios({
  url: `meeting/layout/${uuid}`,
  method: 'delete'
})

/**
 * 场地布局图片
 */
const getPlaceLayoutImg = () => axios({
  url: 'meeting/layout/picture'
})

/**
 * 编辑场地布局图片
 */
const setPlaceLayoutImg = (data) => axios({
  url: 'meeting/layout/picture',
  method: 'put',
  data
})

/**
 * 会议室预约操作
 */
const putMeetingAppointment = (data) => axios({
  url: `meeting/order/${data.uuid}?status=${data.status}`,
  method: 'put'
})

/**
 * 会议室订单开票信息（发票类型(只有普通发票)和发票内容固定写死）
 */
const getInvoice = (uuid) => axios({
  url: `meeting/order/invoice/${uuid}`,
})

/**
 * 编辑会议室订单背景图片
 */
const setMeetingBg = (data) => axios({
  url: 'meeting/order/backgroundPicture',
  method: 'put',
  data
})

/**
 * 编辑会议室标题(待审核和未开始情况下可编辑)
 */
const setMeetingTitle = (data) => axios({
  url: '/meeting/order/meetingTitle',
  method: 'put',
  data
})

export {
  getMeetingList,
  addMeeting,
  getMeetingDetails,
  putMeeting,
  deleteMeeting,
  getAppointmentList,
  appointmentExcel,
  appointmentDetails,
  getAddServerList,
  setAddServer,
  addMeetingServer,
  deleteServer,
  setBasicServer,
  getMeetingFunList,
  putMeetingFun,
  deleteMeetingFun,
  addMeetingFun,
  getPlaceList,
  setMeetingFun,
  getMeetingFun,
  getBasicServer,
  setPlaceLayout,
  addPlaceLayout,
  deletePlaceLayout,
  getPlaceLayoutImg,
  setPlaceLayoutImg,
  putMeetingAppointment,
  updateMeetingTitle,
  getInvoice,
  setMeetingBg,
  setMeetingTitle
}
